import { claimFriend } from '../../../../../../../app/backend/store/referrals';
import Settings from '../../../../../../settings/Settings';

const LABEL = {
    FONT: Settings.FONTS.LXGW_CYRILLIC_BOLD,
    SIZE: 46,
    TINT: 0xffffff,
};

export default class Button extends Phaser.GameObjects.Container {
    private sprite!: Phaser.GameObjects.Image;
    private icon!: Phaser.GameObjects.Image;
    private label!: Phaser.GameObjects.BitmapText;
    private hackneyId: string

    constructor(scene: Phaser.Scene, x: number, y: number, hackneyId: string) {
        super(scene, x, y);

        this.hackneyId = hackneyId;

        this.setupSprite();
        this.setupIcon();
        this.setupLabel();
    }

    setupSprite() {
        let frame = 'gui/friends/button_claim';

        this.sprite = this.scene.add.image(0, 0, 'atlas', frame);
        this.add(this.sprite);

        this.sprite.setInteractive({ useHandCursor: true });
        this.sprite.on('pointerdown', this.claim, this)
    }

    async claim() {
        console.log("Claim " + this.hackneyId)
        this.scene.events.emit('top_up_hard', { x: this.icon.getWorldTransformMatrix().tx, y: this.icon.getWorldTransformMatrix().ty })
        await claimFriend(this.hackneyId) // Context will be lost after that line
    }

    setupIcon() {
        let x = 45;
        let y = 0;

        let frame = 'gui/hard_currency/icon';

        this.icon = this.scene.add.image(x, y, 'atlas', frame);
        this.icon.setScale(0.8)
        this.add(this.icon);
    }

    setupLabel() {
        let x = 12;
        let y = -2;
        let text = '+20';

        this.label = this.scene.add.bitmapText(x, y, LABEL.FONT, text, LABEL.SIZE);
        this.label.setOrigin(1, 0.5);
        this.label.setTint(LABEL.TINT);
        this.add(this.label);
    }
}
